module.exports = __webpack_public_path__ + "img/edit-request-icon.e3c0a16a.svg";